import { getField } from 'vuex-map-fields'

export const getters = {
  getField,
  cart: state => { return state.cart },
  booking: state => { return state.booking },
  bookingHome: state => { return state.bookingHome },
  contact: state => { return state.contact },
  payment: state => { return state.payment },
  pricing: state => { return state.pricing },
  puroadLevel: state => { return state.puroadLevel },
  shouldDisplayErrors: state => { return state.shouldDisplayErrors },
  responsiblePerson: state => {
    return state.cart.people.find(person => person.id === state.cart.responsiblePersonId) || null
  },
  distributedLuggage: state => {
    let distributedLuggageSmall = state.cart.people.reduce(function(prev, cur) {
      return prev + cur.luggageSmall
    }, 0)

    let distributedLuggageLarge = state.cart.people.reduce(function(prev, cur) {
      return prev + cur.luggageLarge
    }, 0)

    return {
      small: distributedLuggageSmall,
      large: distributedLuggageLarge,
    }
  },
  prices: (state) => {
    const isShadowMode = process.env.VUE_APP_PRICING_SHADOW_MODE === 'true';
    const useServerPricing = process.env.VUE_APP_PRICING_SOURCE !== 'legacy' && !isShadowMode;
    const serverBreakdown = state.pricing && state.pricing.priceBreakdown ? state.pricing.priceBreakdown : null;

    if (useServerPricing && serverBreakdown) {
      state.payment.totalPreCoupon = serverBreakdown.totalPreCoupon;
      state.payment.couponValueCU = serverBreakdown.couponReduction;
      return {
        zip: serverBreakdown.zip,
        travel: serverBreakdown.travel,
        departtravel: serverBreakdown.departtravel,
        people: serverBreakdown.people,
        luggageSmall: serverBreakdown.luggageSmall,
        luggageLarge: serverBreakdown.luggageLarge,
        total: serverBreakdown.total,
        totalHome: serverBreakdown.totalHome,
        luggagePlasticBag: serverBreakdown.luggagePlasticBag,
        luggageAirshell: serverBreakdown.luggageAirshell,
        priceAddition: serverBreakdown.priceAddition
      };
    }

    const areaZero = ['2791','2770']
    
    const areaOne = ['3100','3120','3140','3150','3200','3210','3220','3230','3250','3300','3310','3320','3360','3370','3390','3630','4050','4060','4070','4100','4105','4130','4140','4160','4171','4173','4174','4180','4190','4200','4220','4230','4241','4242','4243','4250','4261','4262','4270','4281','4291','4293','4295','4296','4300','4320','4330','4340','4350','4360','4370','4390','4400','4420','4440','4450','4460','4470','4480','4490','4500','4520','4532','4534','4540','4550','4560','4571','4572','4573','4581','4583','4591','4592','4593','4632','4640','4652','4653','4654','4660','4671','4672','4673','4681','4682','4683','4684','4690','4700','4720','4733','4735','4736','4750','4760','4771','4772','4773']

    const areaTwo = ['4780','4791','4792','4793','4800','4840','4850','4862','4863','4871','4872','4873','4874','4880','4891','4892','4894','4895','4900','4912','4913','4920','4930','4941','4943','4944','4951','4952','4953','4960','4970','4983','4990']

    const areaThree = ['3000', '3050', '3060', '3070', '3450', '3460', '3500', '3520', '3540', '3660', '3670' ,'4000', '4030', '4600', '4621', '4622','4623']

    const areaFour = ['3080','3330','3400','3480','3490','3550','3600','3650','4040']


    // Get the current date
    const currentDate = new Date();
    const targetDate = new Date('2025-04-01');
    // Determine if the current date is after the target date
    const newPrice = currentDate > targetDate;
    
    const oddsizePrice = newPrice ? 95 : 95;
    const normalbagPrice = newPrice ? 75 : 65;
    const basePrice = 395;
    const paxPrice = newPrice ? 55 : 45;
    const zip0Price = newPrice ? 495 : 465; //indre kbh
    const zip1Price = newPrice ? 475 : 445;
    const zip2Price = newPrice ? 585 : 545;
    const zip3Price = newPrice ? 635 : 595;
    const zip4Price = newPrice ? 685 : 645;
    const zip5Price = 1095;
    const zip6Price = 1295;

    let luggageSmallTotal = state.cart.luggageSmall.amount > 4 ? ((state.cart.luggageSmall.amount - 4) * normalbagPrice) : 0; 
    state.cart.luggageSmall.price = luggageSmallTotal;
    if (state.cart.luggageLarge.amount<0) state.cart.luggageLarge.amount=0;
    //let luggageLargeTotal = state.cart.luggageLarge.amount * 95; /*changed from 75 dkk*/
    //let luggageLargeTotal = state.cart.luggageLarge.amount > 1 ? ((state.cart.luggageLarge.amount - 1) * 95) : 0; //if one odd size is free
    
    var largelug=0;

    /*if (getBookingDate(state).getMonth()<=2 && getBookingDate(state).getMonth()>=1) {
      if (state.cart.luggageLarge.amount>0) largelug=-1*75;
      if (console) console.log("newletter = " + state.payment.newsletter);
    }*/
    let luggageLargeTotal = state.cart.luggageLarge.amount * oddsizePrice + largelug; /*changed from 75 dkk*/
    
    if (luggageLargeTotal<=0)  {state.cart.luggageAirshell.amount=0;state.cart.luggagePlasticBag.amount=0}
    let luggagePlasticBagTotal = state.cart.luggagePlasticBag.amount *state.cart.luggagePlasticBag.price  ;
    let luggageAirshellTotal = state.cart.luggageAirshell.amount * paxPrice; 
    
    
    let peopleTotal = state.cart.people.length > 4 ? (state.cart.people.length - 4) * paxPrice : 0; /*change from 30 to 55 dkk*/
    let travelTotal = 0;
    let zip = state.contact.address.zip

    
    if (areaZero.includes(zip)) {
      travelTotal += basePrice
    }
    else if (parseInt(zip) < 2300 && parseInt(zip) >= 1000) {
      travelTotal = zip0Price
    }
    else if (parseInt(zip) < 2800 && parseInt(zip) >= 1000) {
      travelTotal += zip1Price
    } else if(parseInt(zip) < 3000 && parseInt(zip) >= 2800) {
      travelTotal += zip2Price
    } else if(areaThree.includes(zip)) {
      travelTotal += zip3Price
    } else if(areaFour.includes(zip)) {
      travelTotal += zip4Price
    } else if(areaOne.includes(zip)) {
      travelTotal += zip5Price
    } else if(areaTwo.includes(zip)) {
      travelTotal += zip6Price
    } else travelTotal = "Fejl";

    const priceAddition = calculatePriceAddition(state);

    const opsmpris = travelTotal
    const udrejseSubtotal = luggageSmallTotal + luggageLargeTotal + peopleTotal + travelTotal + luggagePlasticBagTotal + luggageAirshellTotal;

    // Calculate return service subtotal (hjemrejse)
    let totalHome = 0;
    if (state.cart.serviceHjemrejse && udrejseSubtotal >= 100) {
      totalHome = udrejseSubtotal - (luggagePlasticBagTotal + luggageAirshellTotal + peopleTotal);
    }

    // Selected services subtotal (before coupon)
    const selectedServicesSubtotal =
      (state.cart.serviceUdrejse ? udrejseSubtotal : 0) +
      (state.cart.serviceHjemrejse ? totalHome : 0);

    // For coupon calculation we only allow discount on the selected & enabled services
    const couponEligibleSubtotal =
      ((state.payment.couponIncludeUdrejse && state.cart.serviceUdrejse) ? udrejseSubtotal : 0) +
      ((state.payment.couponIncludeHjemrejse && state.cart.serviceHjemrejse) ? totalHome : 0);

    const couponReduction = calculateCouponPriceReduction(state, couponEligibleSubtotal);

    // Persist pre-coupon total for UI/ordering
    state.payment.totalPreCoupon = selectedServicesSubtotal + priceAddition;

    // Final total
    let allTotal = state.payment.totalPreCoupon - couponReduction;
    if (allTotal < 0) allTotal = 0;

    /* PURoadLevel calculation */
    if (state.puroadLevel.value === 'no' && Number(state.contact.address.zip) < state.puroadLevel.maxPostalNumber) {
      // If both services are selected, use 300 DKK, otherwise use normal fee
      const puroadFee = (state.cart.serviceUdrejse && state.cart.serviceHjemrejse) ? 300 : state.puroadLevel.fee;
      allTotal += puroadFee; /* Just increasing the total */
      state.payment.totalPreCoupon += puroadFee; /* For coupon calculation */
    }

    return {
      zip: zip,
      travel: travelTotal, /* + peopleTotal,  */
      departtravel: opsmpris+peopleTotal+luggageSmallTotal+luggageLargeTotal,  /* Samlet pris for udrejse uden airshells/plastposer*/
      people: peopleTotal,
      luggageSmall: luggageSmallTotal,
      luggageLarge: luggageLargeTotal,
      total: allTotal,
      totalHome: totalHome,
      luggagePlasticBag: luggagePlasticBagTotal,
      luggageAirshell: luggageAirshellTotal,
      priceAddition: priceAddition
    }
  }
};

/*
Calculate addtional price from late booking (and also covid 19 addon)
*/
function calculatePriceAddition(state){

  let addcost = 0;
  const now = new Date();

  const threshold = new Date(now);
  threshold.setHours(threshold.getHours() + 72);

  const calculateServiceLateFee = (serviceDate) => {
    if (!(serviceDate instanceof Date) || Number.isNaN(serviceDate.getTime())) return 0;
    if (serviceDate > threshold) return 0;

    const dateWithoutTime = new Date(serviceDate.getFullYear(), serviceDate.getMonth(), serviceDate.getDate());
    const twoDaysBefore = new Date(dateWithoutTime);
    twoDaysBefore.setDate(twoDaysBefore.getDate() - 2);
    const noonTwoDaysBefore = new Date(twoDaysBefore);
    noonTwoDaysBefore.setHours(12, 0, 0, 0);

    return now > noonTwoDaysBefore ? 300 : 150;
  };

  // Departure (udrejse)
  if (state.cart.serviceUdrejse && state.booking && state.booking.date) {
    addcost += calculateServiceLateFee(getBookingDate(state));
  }

  // Return (hjemrejse)
  if (state.cart.serviceHjemrejse && state.bookingHome && state.bookingHome.dateHome) {
    addcost += calculateServiceLateFee(getBookingDateHome(state));
  }

  return addcost;
}

function parseCouponExpiryEndOfDay(value) {
  if (typeof value !== 'string') return null;

  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value.trim());
  if (!match) return null;

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const expiryDate = new Date(year, month - 1, day, 23, 59, 59, 999);
  const isValid = expiryDate.getFullYear() === year
    && expiryDate.getMonth() === month - 1
    && expiryDate.getDate() === day;

  return isValid ? expiryDate : null;
}


function calculateCouponPriceReduction(state, total) {
  let returnvalue = 0;
  let startdate= new Date();
  var fnr = "";// state.booking.flightNumber.replace(/\D/g, ''); // flynummer uden bogstaver

  if (!total || total <= 0) {
    state.payment.couponValueCU = 0;
    return 0;
  }

  if (state.payment.coupon.length==1) state.payment.couponValue = 0;
  
  // ***  VALUE CARD
  if (state.payment.couponType === 'Value card') {
    const expiryDate = parseCouponExpiryEndOfDay(state.payment.couponExpirydate)
    if (expiryDate && expiryDate >= new Date()) {
      const capped = Math.min(state.payment.couponValue, total);
      state.payment.couponValueCU = capped;
      return capped;
    } else {
      return 0;
    }
  }

  // *** PROCENT RABAT
  if(state.payment.couponType !== "Fast beløb") {
    switch (state.payment.coupon.toLowerCase()) {
      case 'retur10pct':
        fnr = state.booking.flightNumber.replace(/\D/g, ''); // flynummer uden bogstaver    
        // gælder for rejser i perioden oktober til marts
        
        if (getBookingDateHome(state).getFullYear()>2000) { //  9 || getBookingDate(state).getMonth()<3) {
          state.payment.couponValueCU = total * (state.payment.couponValue/100);
          returnvalue= total * (state.payment.couponValue/100); //&& state.cart.luggageLarge.amount>0) return (total * (state.payment.couponValue));
        } else {
          state.payment.couponValueCU = 0;
          state.payment.couponValue = 0;
          state.payment.coupon = '';
          returnvalue= 0;
        }
        break;

      case "sas10":
        fnr = state.booking.flightNumber.replace(/\D/g, ''); // flynummer uden bogstaver
        startdate=new Date(2023,10,6);
        if  (state.booking.airline=="SAS" && fnr<7000 && (new Date() >= startdate)) { 
          state.payment.couponValueCU = total * (state.payment.couponValue/100);
          returnvalue= total * (state.payment.couponValue/100); //&& state.cart.luggageLarge.amount>0) return (total * (state.payment.couponValue));
        } else {
          state.payment.couponValueCU = 0;
          state.payment.couponValue = 0;
          state.payment.coupon = '';
          returnvalue= 0;
        }
      break;

      default:
        state.payment.couponValueCU = total * (state.payment.couponValue/100);
        returnvalue = (total * (state.payment.couponValue/100));
    }
    return returnvalue;
  } 
  // *** FAST BELØB
  else { //Fast beløb
    // Gratis oddsize ved bestilling for SK-rute, 22 jan-5 feb 2024
    // getBookingDate(state).getMonth()<3 tager fat i booking datoen IKKE aktuel dato hvor der bookes
    // if (console) console.log("booking date = " + new Date(2023, 9, 2) + " / " + new Date());
    fnr = state.booking.flightNumber.replace(/\D/g, ''); // flynummer uden bogstaver
    // if (console) console.log("FAST BELØB kode");
    // if (console) console.log("kupon = " + state.payment.coupon.toLowerCase());
    switch(state.payment.coupon.toLowerCase()) {
      case"sas24":
        // gælder frem til 15 oktober, 1 gratis oddsize
        if  (state.cart.luggageLarge.amount>0 && state.booking.airline=="SAS" && fnr<7000 && new Date() >= new Date(2024, 0, 22)) { // getBookingDate(state) >= new Date(2023, 9, 2)) { //&& getBookingDate(state).getMonth()<3 ) {
          // if (console) console.log('sas kupon ' + fnr); 
          // if (console) console.log("oddSAS = " + state.booking.airline + state.booking.flightNumber);
          state.payment.couponValueCU = state.payment.couponValue;
          //state.payment.newsletter = true; // nyhedsbrev er krav for at få rabat
          //return state.payment.couponValue;
          returnvalue=state.payment.couponValue;
        }
        else {
          // if (console) console.log('gratis02 kupon nulstilles');
          state.payment.couponValueCU = 0;
          state.payment.couponValue = 0;
          state.payment.coupon = '';
          returnvalue=0
          //return 0;
        }
      break;

      case "sasski": //1 free oddsize
        // Only SK scheduled flights
        // gælder 23-29 oktober 2023
        startdate = new Date(2023,9,23);
        //let enddate = new Date(2023,9,29); set in coupon value
        if  (state.cart.luggageLarge.amount>0 && state.booking.airline=="SAS" && fnr<7000 && new Date() >= startdate) { // getBookingDate(state) >= new Date(2023, 9, 2)) { //&& getBookingDate(state).getMonth()<3 ) {
          state.payment.couponValueCU = state.payment.couponValue;
          returnvalue=state.payment.couponValue;
        }
        else { // nulstille værdien hvis den ikke er gyldig
          state.payment.couponValueCU = 0;
          state.payment.couponValue = 0;
          state.payment.coupon = '';
          returnvalue=0
          //return 0;
        }
      break;

      default:
          state.payment.couponValueCU = Math.min(state.payment.couponValue, total);
          returnvalue= Math.min(state.payment.couponValue, total)
    } // end Switch
    // Ensure fixed coupons never exceed eligible subtotal
    return Math.min(returnvalue, total);

    /*
    if (state.payment.coupon.toLowerCase()=='sas23'){
      let fnr = state.booking.flightNumber.replace(/\D/g, ''); // flynummer uden bogstaver
      if  (state.cart.luggageLarge.amount>0 && state.booking.airline=="SAS" && fnr<7000 && new Date() >= new Date(2023, 9, 2)) { // getBookingDate(state) >= new Date(2023, 9, 2)) { //&& getBookingDate(state).getMonth()<3 ) {
        // if (console) console.log('sas kupon ' + fnr);
        // if (console) console.log("oddSAS = " + state.booking.airline + state.booking.flightNumber);
        state.payment.couponValueCU = state.payment.couponValue;
        //state.payment.newsletter = true; // nyhedsbrev er krav for at få rabat
        return state.payment.couponValue;
      }
      else {
        // if (console) console.log('gratis02 kupon nulstilles');
        state.payment.couponValueCU = 0;
        state.payment.couponValue = 0;
        state.payment.coupon = '';
        return 0;
      }
    }
    else if (state.payment.coupon.toLowerCase()=='fortov') {
      //if (getBookingDate(state).getMonth()>=1 && getBookingDate(state).getMonth()<=2 && state.cart.luggageLarge.amount>0 ) {
      if (state.contact.address.zip<2300) {
        //alert('Denne rabatkode gælder for medlemmer af nyhedsbrevet');
        //state.payment.newsletter = true;
        alert('Rabatkode gælder når bagage hentes ved fortov ' );
        state.payment.couponValueCU = state.payment.couponValue;
        return state.payment.couponValue;
      } else {
        alert('Rabatkode gælder ved opsamling fra fortov i indre KBH ' + state.contact.address.zip);
        state.payment.couponValueCU = 0;
        state.payment.couponValue = 0;
        return 0;
      }
    } else {
      state.payment.couponValueCU = state.payment.couponValue;
      return state.payment.couponValue;
    }*/
  }  // end of "fast beløb"
}


function parseBookingDate(value) {
  if (value instanceof Date) return new Date(value.getTime());
  if (typeof value !== 'string') return new Date(value);

  const trimmed = value.trim();
  const danishDate = trimmed.match(/^(\d{1,2})[-./](\d{1,2})[-./](\d{4})$/);

  if (danishDate) {
    const day = Number(danishDate[1]);
    const month = Number(danishDate[2]) - 1;
    const year = Number(danishDate[3]);

    return new Date(year, month, day);
  }

  return new Date(trimmed);
}

function applyBookingTime(date, time) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return date;
  if (!time || time.HH === "" || time.mm === "") return date;

  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    Number(time.HH),
    Number(time.mm)
  );
}

function getBookingDate(state){
  return applyBookingTime(parseBookingDate(state.booking.date), state.booking.time);
}

function getBookingDateHome(state){
  return applyBookingTime(parseBookingDate(state.bookingHome.dateHome), state.bookingHome.timeHome);
}
